import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { deleteTeacher, getTeachers } from "../../../../services/teacherService";
import { message } from "antd";

const useTeacherManagement = () => {
  const { t } = useTranslation();
  const [teachers, setTeachers] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  useEffect(() => {
    fetchTeachers();
  }, []);

  const fetchTeachers = async (filters: any = { page: 1, limit: 10 }) => {
    setIsLoading(true);
    try {
      const response = await getTeachers(filters);
      setTeachers(response.data);
      setPagination(response.pagination)
    } catch (error) {
      message.error(t("failed_to_fetch_teachers"));
    } finally {
      setIsLoading(false);
    }
  };

    const handleDelete = async (teacherId: string) => {
    try {
      await deleteTeacher(teacherId);
      message.success(t("teacher_deleted_successfully"));
      return true
    } catch (error) {
      message.error(t("failed_to_delete_teacher"));
      return false
    }
  };

 

  return {
    teachers,
    isLoading,
    fetchTeachers,
    pagination,
    handleDelete
  };
};

export default useTeacherManagement;